import type React from 'react';
import { useEffect } from 'react';

/**
 * Hook that detects clicks outside of the passed refs with option to specify refs to ignore
 */
export const useClickOutsideDetector: (
  refs: React.MutableRefObject<HTMLDivElement | HTMLUListElement | null>[],
  callback: () => void,
  ignoreRefs: React.MutableRefObject<HTMLDivElement | null>[]
) => void = (refs, callback, ignoreRefs = []) => {
  useEffect(() => {
    const handleClickOutside: (event: MouseEvent) => void = event => {
      const ignoreElement = ignoreRefs.some(ignoreRef => {
        return ignoreRef.current?.contains(event.target as Node);
      });
      if (!ignoreElement && refs.every(ref => !ref.current?.contains(event.target as Node))) {
        callback();
      }
    };
    // Opening the calendar scrolls the page, so a click can be released over a different element
    document.addEventListener('mousedown', handleClickOutside, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [refs, callback, ignoreRefs]);
};
